
import { useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import {  Grid, createStyles, Tooltip, Indicator, Avatar, Group, Switch } from '@mantine/core';
import { setuphelp_userhavetoident } from '../../slice/mainslice'
import React from "react";

const useStyles = createStyles((theme) => ({
    margright: {
        marginRight: 10,
        cursor: 'pointer',
      },
}));

const SetupUserToIdentify = (props: any) => {
    const { classes } = useStyles(); 
    const dispatch = useDispatch()
    const initparticipants = useSelector((state: any) => state.user.meetinguser)
    const[usertoidentiy, setUserToIdentivy] = useState<any>([]);

      // User
    const data = initparticipants.filter((obj: { role: any; }) => {
    return (obj.role !== "notar" && obj.role !== "gast")
    });
  
    //console.log(usertoidentiy)

    const updateArray = (value: boolean,index: number) => {
        console.log(value);
        setUserToIdentivy((prevusersigndocs: any) => {
            let updatedArray = [...prevusersigndocs];
            const existingIndex = updatedArray.findIndex((item: any) => item.participantId === data[index].id);
        
            if (existingIndex === -1) {
                // Wenn kein Eintrag für die gegebene participantId existiert, füge einen neuen Eintrag hinzu
                updatedArray.push({ participantId: data[index].id, isToBeIdentified: value });
            } else {
                // Wenn ein Eintrag für die gegebene participantId existiert, erstelle eine Kopie des Eintrags und aktualisiere die Kopie
                const updatedItem = { ...updatedArray[existingIndex], isToBeIdentified: value };
                // Aktualisiere das Array mit der aktualisierten Kopie
                updatedArray[existingIndex] = updatedItem;
            }

             
             //else {
            //  const newData = { participantId: data[index].id, isToBeIdentified: value };
            //  updatedArray.push(newData);
                //updatedArray = updatedArray.filter((item: any) => item.id !== data[index].id);
            //}
          dispatch(setuphelp_userhavetoident(updatedArray))
        return updatedArray;
        });
      };

    
    
    const rows = (data || []).map((item: any, index: any) => {
        let checked = false;
        if (usertoidentiy && usertoidentiy.length > 0) {
            const identifiedItem = usertoidentiy.find((userItem: any) => userItem.participantId === item.id );
                if (identifiedItem) {
                    checked = identifiedItem.isToBeIdentified;
                } else {
                    checked = item.isToBeIdentified
                }
        } else {
            checked = item.isToBeIdentified
        }


       // console.log(item)
       // console.log(item.isToBeIdentified)
      
        let fullname = item.lastName + " " + item.firstName

        let a = item.lastName.substring(0,1)
        let b = item.firstName.substring(0,1)
        let initialen = a + b

        let inmeetingcolor = "red"
        if (item.meetingParticipantStatus === null) {
          inmeetingcolor = "red"
        }
        if (item.meetingParticipantStatus === "LeftMeeting") {
          inmeetingcolor = "red"
        }
        if (item.meetingParticipantStatus === "InMeeting") {
          inmeetingcolor = "green"
        }

        return (
            <React.Fragment key={item.id || index}>
            
            <Grid.Col span={6}>
                <Group>
            <Indicator inline size={8} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
                        <Avatar   alt={fullname} variant="filled" radius="xl" size="sm">{initialen} </Avatar>
                    </Indicator>
            {fullname}
            </Group>
            </Grid.Col>
                <Grid.Col span={1} className={classes.margright}>
                    <Tooltip label={fullname} multiline={true}>
                        <Switch  checked={checked}  onChange={(event) => updateArray(event.currentTarget.checked, index)} />
                    </Tooltip>
                </Grid.Col>
            </React.Fragment>
        );
    });

    return (
        <>
            <Grid>
                {rows}
            </Grid>
        <hr/>
        </>
    );
}

export default SetupUserToIdentify;